export function trackPageView(pathname: string): void {
  gtag('event', 'page_view', {
    page_path: pathname,
    page_title: document.title,
  });
}

export function initClickTracking(): () => void {
  const handler = (e: MouseEvent): void => {
    const el = (e.target as HTMLElement).closest('[data-track]');
    if (!el) return;
    const trackValue = el.getAttribute('data-track');
    if (!trackValue) return;
    gtag('event', 'ui_click', {
      event_category: 'engagement',
      event_label: trackValue,
      page_path: window.location.pathname,
    });
  };
  document.addEventListener('click', handler);
  return () => document.removeEventListener('click', handler);
}
